import { useState, useEffect } from 'react'
import { Input, Select } from '../../components/forms'
import Button from '../../components/ui/Button'

const ROLE_OPTIONS = [
  { value: 'member', label: 'Member' },
  { value: 'admin', label: 'Admin' },
]

function UserEditForm({ user, onSubmit, onCancel, loading = false, businesses = [], initialBusinessIds = [] }) {
  const [formData, setFormData] = useState({
    name: user?.name || '',
    role: user?.role || 'member',
    businessIds: initialBusinessIds,
  })

  useEffect(() => {
    setFormData(prev => ({
      ...prev,
      businessIds: initialBusinessIds,
    }))
  }, [initialBusinessIds])

  const handleChange = (e) => {
    const { name, value } = e.target
    setFormData(prev => ({ ...prev, [name]: value }))
  }

  const handleBusinessToggle = (businessId) => {
    setFormData(prev => ({
      ...prev,
      businessIds: prev.businessIds.includes(businessId)
        ? prev.businessIds.filter(id => id !== businessId)
        : [...prev.businessIds, businessId]
    }))
  }

  const handleSubmit = (e) => {
    e.preventDefault()
    onSubmit(formData)
  }

  return (
    <form onSubmit={handleSubmit}>
      <Input
        label="Name"
        name="name"
        type="text"
        value={formData.name}
        onChange={handleChange}
        placeholder="John Doe"
      />

      <div className="form-group">
        <label className="form-label">Email</label>
        <input
          type="email"
          className="form-input"
          value={user?.email || ''}
          disabled
          style={{ opacity: 0.6, cursor: 'not-allowed' }}
        />
        <p className="text-muted text-sm mt-1">Email cannot be changed</p>
      </div>

      <Select
        label="Role"
        name="role"
        value={formData.role}
        onChange={handleChange}
        options={ROLE_OPTIONS}
      />

      {businesses.length > 0 && (
        <div className="form-group">
          <label className="form-label">Business Access</label>
          <p className="text-muted text-sm mb-2">
            Select which businesses this user can access
          </p>
          <div className="business-access-list">
            {businesses.map(business => (
              <label key={business.id} className="checkbox-item">
                <input
                  type="checkbox"
                  checked={formData.businessIds.includes(business.id)}
                  onChange={() => handleBusinessToggle(business.id)}
                />
                <span className="checkbox-label">
                  {business.emoji} {business.name}
                </span>
              </label>
            ))}
          </div>
        </div>
      )}

      <div className="flex justify-between gap-3 mt-6">
        <Button type="button" variant="secondary" onClick={onCancel}>
          Cancel
        </Button>
        <Button type="submit" variant="primary" loading={loading}>
          Save Changes
        </Button>
      </div>
    </form>
  )
}

export default UserEditForm
